import { createSlice } from '@reduxjs/toolkit';
import { defaultExtraChargesSlice } from '@/redux/modules/billingManagement/extraCharges/extraCharges.types';
import {
    fetchExtraChargeTypes,
    saveExtraCharge,
} from '@/redux/modules/billingManagement/extraCharges/extraCharges.actions';

export const extraChargesSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchExtraChargeTypes.fulfilled, (slice, { payload }) => {
            slice.extraChargesTypes = payload;
        });

        builder.addCase(saveExtraCharge.pending, (slice) => {
            slice.wasSaveSuccessful = undefined;
        });
        builder.addCase(saveExtraCharge.fulfilled, (slice) => {
            slice.wasSaveSuccessful = true;
        });
        builder.addCase(saveExtraCharge.rejected, (slice) => {
            slice.wasSaveSuccessful = false;
        });
    },
    initialState: defaultExtraChargesSlice,
    name: 'extraCharges',
    reducers: {},
});

export const { reducer: extraChargesReducer } = extraChargesSlice;
